import { Colors, isEmpty } from '@sigma-frontend-libs/commons'

import { getFile, getStorageURL, icons } from '@/utils'

import { fileInfo, serviceNameViaPoint } from '@/components/services/report-manager/queue/utils'

import render from './render'

export default {
  name: 'Item',

  mixins: [ getFile, fileInfo ],

  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  computed: {
    hasFilterBy() {
      return Object.values(this.value?.filterBy || {}).some(value => {
        if (Array.isArray(value)) {
          return Boolean(value.length)
        }

        return !isEmpty(value)
      })
    },

    countTooltip() {
      const runCount = this.value.runCount
      const failureCount = this.value.failureCount

      if (typeof runCount === 'number' && typeof failureCount === 'number') {
        return this.getTranslate(`${serviceNameViaPoint}.tooltips.count`, {
          runCount,
          failureCount
        })
      }
    },

    downloadButton() {
      if (this.value.fileId && !this.fileNotFound) {
        return {
          icon: icons.download,
          color: Colors.info,
          loading: this.fileLoading,
          disabled: this.fileLoading,
          tooltip: this.fileLabel,
          callback: () => {
            return window.location.href = getStorageURL([ this.value.fileId ])
          }
        }
      }
    }
  },

  render
}
